import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {withRouter} from 'react-router';
import { connect } from 'react-redux';
import { getMetaTags } from '../../utils/Utils';

const mapStateToProps = (state) => {
    return {
        localizationState: state.get('localization')
    };
};

@connect(mapStateToProps)
class ErrorView extends React.Component {
    static propTypes = {
        localizationState: PropTypes.object,
        status: PropTypes.number
    };

    render() {
        const localizationState = this.props.localizationState;
        const tags = getMetaTags(localizationState);
        const messages = localizationState.get('messageProperties');
        const status = this.props.status;
        return (
            <div>
                <Helmet
                    meta={tags}
                    title={messages.get('epic.enterprise.social.meta.site_name')} />
                <div className="enterprise-wrapper">
                    {status} error occurs
                </div>
            </div>
        );
    }
}

export default withRouter(ErrorView);
